import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { ErrorMessage } from "@hookform/error-message";
import PublicLayout from "../templates/PublicLayout";
import { api } from "../axiosInstance/axiosInstance";
import { useNavigate } from "react-router-dom";
import companyImageWelcome from "../assets/companyImageWelcome.png";

const schema = z.object({
  FNAME: z.string().min(1, "Nome é obrigatório"),
  EMAIL: z.string().email("Email inválido"),
  PHONE: z.string().min(10, "Telefone inválido"),
  AREA: z.string().min(1, "Área de atuação é obrigatória"),
});

const LandingPage = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
  });

  const navigate = useNavigate();

  useEffect(() => {
    const previousTitle = document.title;
    document.title = "E-Book | Fonoaudiologia na Prática";

    return () => {
      document.title = previousTitle;
    };
  }, []);

  const onSubmit = async (data: any) => {
    try {
      await api.post("/leading-page", data);
      navigate("/baixar-ebook", { state: { email: data?.EMAIL } });
    } catch (error: any) {
      navigate("/baixar-ebook", { state: { email: data?.EMAIL } });
    }
  };

  return (
    <PublicLayout>
      <div className="min-h-screen flex flex-col md:flex-row">
        
        <div className="w-full md:w-1/2 flex items-center justify-center bg-gray-100">
          <img
            src={companyImageWelcome}
            alt="Representação"
            className="w-full h-full object-cover md:rounded-sm"
          />
        </div>

        <div className="w-full md:w-1/2 flex items-center justify-center p-6">
          <main className="w-full max-w-md">
            <div className="mt-7 bg-white border border-gray-200 rounded-xl shadow-sm">
              <div className="p-4 sm:p-7">
                <div className="text-center">
                  <h1 className="block text-2xl font-bold text-cyan-800">
                    Receba um eBook gratuito!
                  </h1>
                  <p className="mt-2 text-gray-600">
                    Preencha os dados abaixo e receba um ebook exclusivo que ajudará você a planejar a sua terapia!
                  </p>
                </div>

                <div className="mt-5">
                  <form
                    action="https://fonotherapp.us22.list-manage.com/subscribe/post?u=3ea855e3e124a09173b274f12&amp;id=4627df7617&amp;f_id=0030c2e1f0"
                    method="post"
                  >
                    <div className="grid gap-y-4">
                      <div>
                        <label className="block text-sm mb-2">Nome</label>
                        <input
                          type="text"
                          {...register("FNAME")}
                          className="py-3 border-2 px-4 block w-full border-gray-200 rounded-lg text-sm focus:outline-cyan-500 focus:ring-cyan-500"
                        />
                        <ErrorMessage
                          name="FNAME"
                          errors={errors}
                          render={({ message }) => <p className="text-red-600 text-sm mt-1">{message}</p>}
                        />
                      </div>

                      <div>
                        <label className="block text-sm mb-2">Email</label>
                        <input
                          type="email"
                          {...register("EMAIL")}
                          className="py-3 border-2 px-4 block w-full border-gray-200 rounded-lg text-sm focus:outline-cyan-500 focus:ring-cyan-500"
                        />
                        <ErrorMessage
                          name="EMAIL"
                          errors={errors}
                          render={({ message }) => <p className="text-red-600 text-sm mt-1">{message}</p>}
                        />
                      </div>

                      <div>
                        <label className="block text-sm mb-2">Telefone</label>
                        <input
                          type="tel"
                          {...register("PHONE")}
                          className="py-3 border-2 px-4 block w-full border-gray-200 rounded-lg text-sm focus:outline-cyan-500 focus:ring-cyan-500"
                        />
                        <ErrorMessage
                          name="PHONE"
                          errors={errors}
                          render={({ message }) => <p className="text-red-600 text-sm mt-1">{message}</p>}
                        />
                      </div>

                      <div>
                        <label className="block text-sm mb-2">Área de Atuação</label>
                        <input
                          type="text"
                          {...register("AREA")}
                          className="py-3 border-2 px-4 block w-full border-gray-200 rounded-lg text-sm focus:outline-cyan-500 focus:ring-cyan-500"
                        />
                        <ErrorMessage
                          name="AREA"
                          errors={errors}
                          render={({ message }) => <p className="text-red-600 text-sm mt-1">{message}</p>}
                        />
                      </div>

                      <div aria-hidden="true" style={{ position: "absolute", left: "-5000px" }}>
                        <input type="text" name="b_3ea855e3e124a09173b274f12_4627df7617" tabIndex={-1} value="" />
                      </div>
                      
                      <button
                        type="submit"
                        className="w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent bg-primary text-white hover:bg-cyan-600 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2"
                      >
                        Enviar
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </PublicLayout>
  );
};

export default LandingPage;
